const middleware = {}

middleware['authroute'] = require('../middleware/authroute.js')
middleware['authroute'] = middleware['authroute'].default || middleware['authroute']

middleware['exbt-preview-redirect'] = require('../middleware/exbt-preview-redirect.js')
middleware['exbt-preview-redirect'] = middleware['exbt-preview-redirect'].default || middleware['exbt-preview-redirect']

middleware['mobileRedirect'] = require('../middleware/mobileRedirect.js')
middleware['mobileRedirect'] = middleware['mobileRedirect'].default || middleware['mobileRedirect']

middleware['noSessionRoute'] = require('../middleware/noSessionRoute.js')
middleware['noSessionRoute'] = middleware['noSessionRoute'].default || middleware['noSessionRoute']

middleware['seoMeta'] = require('../middleware/seoMeta.js')
middleware['seoMeta'] = middleware['seoMeta'].default || middleware['seoMeta']

middleware['token'] = require('../middleware/token.js')
middleware['token'] = middleware['token'].default || middleware['token']

export default middleware
